import { dynamicLoader } from '~/utils';

export const ProjectTransitioner = dynamicLoader({
  name: 'ProjectTransitioner',
  importFunc: () => import('./project-transitioner'),
});

export const ProjectTransitionerPopup = dynamicLoader({
  name: 'ProjectTransitionPopup',
  importFunc: () => import('./project-transition-popup'),
});